import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import { postData } from "../Api";

function Register() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await postData("/register", formData);

      setSuccessMessage(response.message || "Registration successful!");
      setShowModal(true);

      setTimeout(() => {
        navigate("/login");
      }, 2000);

      setFormData({
        name: "",
        phone: "",
        email: "",
        password: "",
      });
    } catch (error) {
      console.error("Registration failed:", error);
      alert("Signup Failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <section className="row px-sm-5 py-5 justify-content-center align-items-center">
          <div className="login-container col-lg-6">
            <div id="signupForm">
              <h2 className="text-center fw-bold">Create an Account</h2>
              <p className="text-center">
                If you do not have an account with us, please fill the form
                below to create your account.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="fw-bold">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Full Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold">Phone Number</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="******"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    minLength={6}
                    maxLength={16}
                    title="कम से कम 6 अंक का पासवर्ड"
                  />
                </div>
                <button
                  type="submit"
                  className="btn-style1 w-100"
                  disabled={loading}
                >
                  {loading ? "Signing Up..." : "Signup"}
                </button>
              </form>

              <div className="text-center mt-4">
                <h5 className="fw-bold">Already Have An Account?</h5>
                <Link to="/login">
                  <button className="btn-style1">Login</button>
                </Link>
              </div>
            </div>

            <p className="text-center mt-3 text-muted">
              <small>
                *{" "}
                <span className="text-green fw-bold">Terms & Conditions.</span>{" "}
                <br />
                Your privacy and security are important to us. For more
                information on how we use your data, read our{" "}
                <span className="text-green fw-bold">privacy policy</span>.
              </small>
            </p>
          </div>
        </section>
        <Footer />
      </main>

      {/* ✅ Success Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content py-md-5 py-3 rounded-5">
              <div className="modal-body text-center">
                <div className="popup-icon">
                  <FaCheckCircle size={60} color="green" />
                </div>
                <h2 className="py-md-3 py-2">{successMessage}</h2>
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn-style1"
                  onClick={() => navigate("/login")}
                >
                  Go to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Register;
